module.exports = __webpack_public_path__ + "img/leader_ns_m.917b7bdf.svg";